import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Form, Input, Button, Card, Typography, message, Space, Result } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { api } from '../lib/api';

const { Text } = Typography;

export default function ForgotPasswordPage() {
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const onFinish = async (values: { email: string }) => {
    try {
      setLoading(true);
      await api.auth.forgotPassword(values.email);
      setSent(true);
    } catch (error: any) {
      message.error(error.message || 'Failed to send reset email');
    } finally {
      setLoading(false);
    }
  };

  const primaryColor = '#f46524';
  const cardStyle = {
    width: 420,
    maxWidth: '100%',
    borderRadius: 12,
    border: `1px solid ${primaryColor}`,
    boxShadow: '0 12px 35px rgba(244, 101, 36, 0.25)',
    background: '#fffdfa',
    overflow: 'hidden',
  };

  if (sent) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 24,
          background: '#f5f5f5',
        }}
      >
        <Card style={cardStyle}>
          <Result
            status="success"
            title="Check Your Email"
            subTitle="If an account exists with that email, you will receive password reset instructions."
            extra={
              <Link to="/login">
                <Button type="primary">Back to Login</Button>
              </Link>
            }
          />
        </Card>
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        background: '#f5f5f5',
      }}
    >
      <Card
        title="Reset Password"
        style={cardStyle}
        headStyle={{
          color: primaryColor,
          fontWeight: 600,
          textAlign: 'center',
          background: '#fffdfa',
          borderTopLeftRadius: 12,
          borderTopRightRadius: 12,
        }}
      >
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div style={{ textAlign: 'center' }}>
            <Text type="secondary">
              Enter your email and we'll send you a reset link
            </Text>
          </div>

          <Form
            name="forgot-password"
            onFinish={onFinish}
            autoComplete="off"
            layout="vertical"
            requiredMark={false}
          >
            <Form.Item
              name="email"
              label="Email"
              rules={[
                { required: true, message: 'Required' },
                { type: 'email', message: 'Please enter a valid email' },
              ]}
            >
              <Input
                prefix={<MailOutlined />}
                placeholder="Email address"
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                block
                loading={loading}
              >
                Send Reset Link
              </Button>
            </Form.Item>
          </Form>

          <div style={{ textAlign: 'center' }}>
            <Link to="/login">
              <Text type="secondary">Back to login</Text>
            </Link>
          </div>
        </Space>
      </Card>
    </div>
  );
}
